import { call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { addActionNotification } from 'features/notifications/action-notifications/addActionNotification';
import { selectLocalUserId } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';
import { BreakoutRoomWithUserIds } from 'features/breakout-rooms/types';
import {
  assignLocalUserToBreakoutRoomRequested,
  signalingBreakoutRoomAssistanceRequested,
} from 'features/breakout-rooms/actions';
import { selectBreakoutRoom } from 'features/breakout-rooms/breakoutRoomsSlice';

export function* onBreakoutRoomAssistanceRequestedSaga(
  action: ReturnType<typeof signalingBreakoutRoomAssistanceRequested>
) {
  const localUserId: UserId = yield select(selectLocalUserId);
  if (localUserId === action.payload.initiator.id) {
    // don't show the notification to the initiator
    return;
  }

  const {
    data: { breakoutRoomId },
  } = action.payload;

  const breakoutRoom: BreakoutRoomWithUserIds | undefined = yield select(
    selectBreakoutRoom,
    breakoutRoomId
  );

  if (!breakoutRoom) {
    return;
  }

  const actionNotificationThunk: Action = yield call(
    addActionNotification,
    {
      content: i18n.t('notifications:breakout_rooms.room_request_assistance.content', {
        roomName: breakoutRoom.name,
      }),
      okText: i18n.t('notifications:breakout_rooms.room_request_assistance.btn_ok_label'),
      okAction: assignLocalUserToBreakoutRoomRequested(breakoutRoomId),
      scope: ['breakout-room'],
    },
    {
      toastId: `breakout-assistance-request-${breakoutRoomId}`,
    }
  );

  yield put(actionNotificationThunk);
}
